// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueCookies from 'vue-cookies'    //引入VueCookies
Vue.use(VueCookies)    // 声明使用
Vue.prototype.$store = store;
import LoginVue from "@/components/Login.vue"
Vue.component("LoginVue",LoginVue);//登录组件
Vue.config.productionTip = false
import Print from '@/utils/print.js'
Vue.use(Print)
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

Vue.use(ElementUI,{size:'small',zIndex:3000});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js